import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AgGridModule } from "@bfx/ag-grid-angular";
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
} from "@bfx/ngx-perfect-scrollbar";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DialogModule } from "@bfx/primeng/dialog";
import { TranslateModule } from "@ngx-translate/core";

import { FlexLayoutModule } from "@angular/flex-layout";
import { BfxInterfaceControlsModule } from "app/bfx-interface-controls/bfx-interface-controls.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BmarkSummaryActionSubjectModule } from "../bfx-bmark-summary/bmark-summary-action-subject.module";
import { BmarkSummaryModule } from "../bfx-bmark-summary/bmark-summary.module";
import { BfxDialogsModule } from "../bfx-dialogs/bfx-dialogs.module";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { BfxMenusModule } from "../bfx-menus/bfx-menus.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { OrderEntryModule } from "../order-entry/order-entry.module";
import { BfxHedgeOrderMonitorComponent } from "./bfx-hedge-order-monitor.component";
import { BfxHedgeOrderMonitorService } from "./bfx-hedge-order-monitor.service";
import { BfxHedgeOrderStagingGridComponent } from "./bfx-hedge-order-staging-grid.component";
import { BfxHedgeOrderStagingPanelComponent } from "./bfx-hedge-order-staging-panel.component";
import { BfxHedgeOrderStrategyParametersComponent } from "./bfx-hedge-order-strategy-parameters.component";
import { CommentEditor } from "./editors/CommentEditor";
import { IntentEditor } from "./editors/IntentEditor";
import { TimeEditor } from "./editors/TimeEditor";
import { LockedStagingRowRenderer } from "./renderers/LockedStagingRowRenderer";
import { StrategyParametersRenderer } from "./renderers/StrategyParametersRenderer";
import { BfxHedgeOrderMonitorFilterService } from "./services/bfx-hedge-order-monitor-filtering.service";
import { BfxHedgeOrderMonitorSpotRiskService } from "./services/bfx-hedge-order-monitor-spot-risk.service";
import { BfxHedgeOrderMonitorUtilService } from "./services/bfx-hedge-order-monitor-util.service";
import { CommonIntentRenderer } from "app/bfx-blotter-orders/renderers/CommonIntentRenderer";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [
    BfxHedgeOrderMonitorComponent,
    BfxHedgeOrderStagingPanelComponent,
    BfxHedgeOrderStagingGridComponent,
    BfxHedgeOrderStrategyParametersComponent,
    LockedStagingRowRenderer,
    StrategyParametersRenderer,
    IntentEditor,
    TimeEditor,
    CommentEditor,
  ],
  imports: [
    AgGridModule.withComponents([
      CommonIntentRenderer,
      LockedStagingRowRenderer,
      StrategyParametersRenderer,
      IntentEditor,
      TimeEditor,
      CommentEditor,
    ]),
    BfxBlotterFilterModule,
    BfxElementsLibraryModule,
    BfxMenusModule,
    BfxSharedModule,
    BmarkSummaryModule,
    ButtonModule,
    CheckboxModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    NativeDesktopModule,
    PerfectScrollbarModule,
    TranslateModule,
    DialogModule,
    BfxSharedModule,
    BfxDialogsModule,
    OrderEntryModule,
    BaseComponentsModule,
    BmarkSummaryActionSubjectModule,
    BfxInterfaceControlsModule,
  ],
  exports: [],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxHedgeOrderMonitorService,
    BfxHedgeOrderMonitorFilterService,
    BfxHedgeOrderMonitorUtilService,
    BfxHedgeOrderMonitorSpotRiskService,
  ],
  bootstrap: [BfxHedgeOrderMonitorComponent, BfxHedgeOrderStagingPanelComponent],
})
export class BfxHedgeOrderMonitorModule {}
